export default "__VITE_ASSET__BjMYxlw6__"